/* eslint-disable */
// @ts-nocheck

/* eslint-enable prettier/prettier */
/* eslint-enable @typescript-eslint/no-unused-vars */
/* eslint-enable import/no-unresolved */

import React, { useState } from "react";
import PropTypes from "prop-types";

import { usePublicLocalStorageService } from "@public";
import {
  isTextOption,
  shouldShowWordCloud,
} from "../../../../../utils/surveyOptionTypeUtils";

import WidgetCard from "@untyped-shared/materialUI/widgetCard";

import TextOptionsCard from "./TextOptionsCard";
import SurveyChartCard from "./SurveyChartCard";

function SurveyResultsQuestionRow({ surveyQuestion, textSize = 1.0 }) {
  const { showAccessibleWordCloud } = usePublicLocalStorageService();

  // Handle null/undefined surveyQuestion
  if (!surveyQuestion) {
    return (
      <WidgetCard
        head={I18n.t("surveys.results.error")}
        body={I18n.t("surveys.results.error")}
        smallMargin={!!window.legacyTemplate}
        as="article"
      />
    );
  }

  const options = surveyQuestion.options || [];

  const representedWithWordCloud = shouldShowWordCloud(options[0]);

  const [accessibleViewForWordCloud, setAccessibleViewForWordCloud] = useState(
    showAccessibleWordCloud.read(),
  );

  let row;

  if (options.length < 1) {
    row = I18n.t("js-error-not-logged");
  } else if (isTextOption(options[0])) {
    row = (
      <TextOptionsCard
        option={options[0]}
        showAccessibleView={accessibleViewForWordCloud}
        textSize={textSize}
      />
    );
  } else {
    row = <SurveyChartCard question={surveyQuestion} textSize={textSize} />;
  }

  return (
    <WidgetCard
      head={surveyQuestion.text}
      body={row}
      smallMargin={!!window.legacyTemplate}
      accessibleViewActive={accessibleViewForWordCloud}
      toggleAccessibleView={() => {
        setAccessibleViewForWordCloud((prev) => {
          showAccessibleWordCloud.write(!prev);
          return !prev;
        });
      }}
      showAccessibleViewSwitch={representedWithWordCloud}
      as="article"
      questionId={surveyQuestion.id}
      textSize={textSize}
    />
  );
}

SurveyResultsQuestionRow.propTypes = {
  surveyQuestion: PropTypes.shape({
    id: PropTypes.number.isRequired,
    text: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.string,
        type: PropTypes.string,
        count: PropTypes.number,
        total_answers: PropTypes.number,
      }),
    ),
  }),
};

export default SurveyResultsQuestionRow;
